import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef as CdkDialogRef } from '@angular/cdk/dialog';
import { Observable } from 'rxjs';
import { Action, Transaction } from '../../types';
import { TransactionDataSource } from '../transaction-data-source.class';
import { UI_DIALOG_DATA, UiDialogRef } from '../../ui/dialog/dialog.service';
import { UiDialogShellComponent } from '../../ui/dialog-shell/dialog-shell.component';
import { AsyncPipe } from '@angular/common';
import { EditTransactionsComponent } from '../edit-transactions/edit-transactions.component';

export const EDIT_MANY_TRANSACTIONS_MODAL_CONTENT_CLASS = '!max-w-lg';

@Component({
  selector: 'app-edit-transactions-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './edit-transactions-dialog.component.html',
  styleUrl: './edit-transactions-dialog.component.scss',
  imports: [UiDialogShellComponent, EditTransactionsComponent, AsyncPipe],
})
export class EditTransactionsDialogComponent {
  cdkDialogRef = inject<CdkDialogRef<void, EditTransactionsDialogComponent> | null>(
    CdkDialogRef<void, EditTransactionsDialogComponent>,
    { optional: true },
  );
  uiDialogRef = inject<UiDialogRef<void> | null>(UiDialogRef, { optional: true });

  readonly summaryId = 'edit-transactions-dialog-summary';
  selected$: Observable<Transaction[]>;
  data: {
    transactionDataSource: TransactionDataSource;
  };

  constructor() {
    const cdkData = inject(DIALOG_DATA, { optional: true });
    const uiData = inject(UI_DIALOG_DATA, { optional: true });

    const data = uiData ?? cdkData;
    if (!data) throw new Error('EditTransactionsDialogComponent requires transactionDataSource dialog data.');

    this.data = data;
    this.selected$ = this.data.transactionDataSource.selectedTransactions$;
  }

  transactionListEvent(action: Action) {
    this.close();
    if (action.type === 'CANCEL') return;
    this.data.transactionDataSource.dispatch(action);
    this.data.transactionDataSource.clearSelected();
  }

  private close() {
    this.uiDialogRef?.close();
    this.cdkDialogRef?.close();
  }
}
